import { Box, Typography } from '@mui/material';
import { common } from '@mui/material/colors';
import BaseSlider from 'common/components/base-slider';
import { colors } from 'common/constants';
import React from 'react';
import numeral from 'plugins/numeral';

import { isMobile } from 'react-device-detect';
interface Props {
    name: string;
    configs: {
        step: number;
        scale: number;
    };
    options: {
        id: number;
        label: string;
    }[];
}
const QuestionSliderScale: React.FC<Props> = ({ name, configs, options }) => {
    const { step, scale } = configs;
    const marks = React.useMemo(() => {
        // return [
        //     { value: 0, label: '0' },
        //     {
        //         value: scale,
        //         label:
        //             scale > 1000
        //                 ? numeral(scale).format('0.0a')
        //                 : scale.toString(),
        //     },
        // ];
        if (isMobile) {
            return [
                { value: 0, label: '0' },
                {
                    value: scale,
                    label:
                        scale > 1000
                            ? numeral(scale).format('0.0a')
                            : scale.toString(),
                },
            ];
        }

        const pointCount = Math.floor(scale / step) + 1;

        let labelSpacing = Math.ceil(scale / 10);
        if (labelSpacing % 10 !== 0) {
            labelSpacing = Math.ceil(labelSpacing / 10) * 10;
        }

        return Array.from({ length: pointCount }, (_, index) => {
            const value = index * step;
            const showLabel =
                value % labelSpacing === 0 || value === scale || value === 0;

            return {
                value,
                label: showLabel ? `${value}` : '',
            };
        });
    }, [scale, step]);
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: [2, 5],
            }}
        >
            {options.map((item, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: [
                                '1.2rem',
                                '1.2rem',
                                '1.2rem',
                                '1.4rem',
                                '1.4rem',
                            ],
                            color: [common.white, common.black],
                            fontWeight: [700, 500],
                        }}
                    >
                        {item.label}
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            flexWrap: 'wrap',
                        }}
                    >
                        <BaseSlider
                            name={`${name}.${index}.score`}
                            valueLabelDisplay="auto"
                            step={step}
                            marks={marks}
                            valueLabelFormat={(value) =>
                                value > 1000
                                    ? numeral(value).format('0.0a') + '%'
                                    : value.toString() + '%'
                            }
                            size="medium"
                            max={scale}
                            sx={{
                                '&.MuiSlider-root': {
                                    flex: 1,
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: common.white,
                                    borderRadius: '50%',
                                    color: colors.main,
                                    width: ['2rem', '3rem'],
                                    height: ['2rem', '3rem'],
                                    fontSize: ['0.7rem', '1rem'],
                                    fontWeight: 600,
                                    top: '-20px',
                                },
                                '& .MuiSlider-thumb': {
                                    width: '32px',
                                    height: '32px',
                                    backgroundColor:
                                        'var(--color-primary-light)',
                                },
                                '& .MuiSlider-markLabel': {
                                    color: [common.white, common.black],
                                    fontSize: [
                                        '1.2rem',
                                        '1.2rem',
                                        '1.2rem',
                                        '1.4rem',
                                        '1.4rem',
                                    ],
                                    margin: '8px 0px',
                                    fontWeight: 500,
                                },
                                '& .MuiSlider-rail': {
                                    height: ['1rem'],
                                    opacity: [1, 0.38],
                                    backgroundColor: [
                                        common.white,
                                        '#0000001A',
                                    ],
                                },
                                '& .MuiSlider-track': {
                                    height: ['1rem'],
                                },
                                '& .MuiSlider-mark': {
                                    display: 'none',
                                },
                            }}
                        />
                        <Box
                            sx={{
                                mb: '18px',
                                fontSize: '20px',
                                color: ['#fff', 'black'],
                                ml: ['10px', '10px'],
                            }}
                        >
                            %
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default QuestionSliderScale;
